export const GET_BANKING_CAPACITY_ALL = 'GET_BANKING_CAPACITY_ALL';
export const RESET_BANKING_CAPACITY = 'RESET_BANKING_CAPACITY';

export const GET_BANKING_SEARCH = 'GET_BANKING_SEARCH';